module.exports = __webpack_public_path__ + "img/Weapon_55.56bc9a7c.png";